<div class="signup-page" id="signUpForm">
  <form class="signup-form" (ngSubmit)="onSubmit()" [formGroup]="signUpForm">
    <div class="signup-form__logo">
      <img class="signup-form__logo-image" src="assets/images/frankly.png" alt="Frankly" />
    </div>

    <div class="signup-form__content">
      <!-- Organisation Name -->
      <mat-form-field class="signup-form__field" appearance="fill" floatLabel="always" style="margin-top: 20px">
        <mat-label>Organisation Name</mat-label>
        <input matInput type="text" placeholder="Organisation" minlength="3" maxlength="100"
          formControlName="organisation" />

        @if (signUpForm.get('organisation'); as orgControl) { @if (orgControl.hasError('pattern') && orgControl.touched)
        {
        <mat-error class="signup-form__error"> Allowed characters are numbers, capital letters, small letters and _!()&'
        </mat-error>
        } @if (orgControl.hasError('required') && orgControl.touched) {
        <mat-error class="signup-form__error"> Organisation Name is required </mat-error>
        } @if (orgControl.hasError('maxlength') || orgControl.hasError('minlength')) {
        <mat-error class="signup-form__error"> Organisation Name must be between 3 and 100 characters </mat-error>
        } }
      </mat-form-field>

      <!-- First Name -->
      <mat-form-field class="signup-form__field" appearance="fill" floatLabel="always">
        <mat-label>First Name</mat-label>
        <input matInput type="text" placeholder="First Name" formControlName="firstName" />

        @if (signUpForm.get('firstName'); as firstNameControl) { @if (firstNameControl.hasError('required') &&
        firstNameControl.touched) {
        <mat-error class="signup-form__error">First Name is required</mat-error>
        } }
      </mat-form-field>

      <!-- Last Name -->
      <mat-form-field class="signup-form__field" appearance="fill" floatLabel="always">
        <mat-label>Last Name</mat-label>
        <input matInput type="text" placeholder="Last Name" formControlName="lastName" />

        @if (signUpForm.get('lastName'); as lastNameControl) { @if (lastNameControl.hasError('required') &&
        lastNameControl.touched) {
        <mat-error class="signup-form__error">Last Name is required</mat-error>
        } }
      </mat-form-field>

      <!-- Email -->
      <mat-form-field class="signup-form__field" appearance="fill" floatLabel="always">
        <mat-label>Email</mat-label>
        <input matInput type="email" placeholder="Email" formControlName="emailAddress" />

        @if (signUpForm.get('emailAddress'); as emailControl) { @if ((emailControl.hasError('email') ||
        emailControl.hasError('required')) && emailControl.touched) {
        <mat-error class="signup-form__error">Please enter a valid email address</mat-error>
        } }
      </mat-form-field>

      <!-- Contact Number -->
      <mat-form-field class="signup-form__field" appearance="fill" floatLabel="always">
        <mat-label>Contact Number</mat-label>
        <input matInput type="tel" placeholder="Contact Number" formControlName="phone" />
      </mat-form-field>

      <!-- Terms Agreement -->
      <mat-checkbox formControlName="agreeTerms" class="signup-form__checkbox">
        <a href="https://catchsoftware.com/about-us/privacy-policy/" target="_blank" rel="noopener noreferrer"
          class="signup-form__link signup-form__link--privacy">
          I agree to Catch Software's Privacy Policy
        </a>
      </mat-checkbox>

      <!-- reCAPTCHA -->
      <div [hidden]="!serverError" style="color: #c1272c; font-size: 12px; text-align: center; margin-bottom: 10px"
        role="alert">
        <span>{{ serverError }}</span>
      </div>

      <!-- Submit Button -->
      <div class="signup-form__submit">
        <button class="signup-form__button" mat-raised-button color="primary" type="submit"
          [disabled]="signUpForm.invalid || isServerProcessing">Sign Up</button>
      </div>

      <!-- Confirmation Message -->
      @if (showConfirmationMessage) {
      <div class="signup-form__confirmation">
        <div class="confirmation-toast">
          You're all set! We've sent a link to your inbox to create your password.
        </div>
      </div>
      }

      <!-- Password Reset and Login Links -->
      <div class="signup-form__footer">
        Forgotten your password?
        <a class="signup-form__link signup-form__link--reset" (click)="resetPassword()">Click Here</a>
      </div>
      <div class="signup-form__footer">
        Existing user?
        <a class="signup-form__link signup-form__link--login" (click)="goToLogin()">Login here</a>
      </div>
    </div>
  </form>

  <!-- Loading Spinner -->
  @if (isServerProcessing) {
  <div class="signup-page__spinner">
    <mat-spinner />
  </div>
  }
</div>
